module.exports = __webpack_public_path__ + "img/image-gallery.f0948ac4.png";